import axios from "axios";
import Cookies from "universal-cookie";
import { serverHost } from "../config";
import { IProcessHours } from "../services/SignaturesService";
import { SavingsPlanElementsStatus } from "../services/ElementsService";
import { sanitizeUserProfileForStorage, mergeSanitizedProfile } from "../utils/sanitizeUserProfile";
class Auth
{
    constructor()
    {
        this.isAuthenticated = this.isAuthenticated.bind(this);
        this.getToken = this.getToken.bind(this);
        this.getProfile = this.getProfile.bind(this);
    }

    getPublicWebUserData()
    {
        var userProfile = this.getUserProfile();

        const lastContractActiveId = userProfile.lastContractActive;

        let matchingSavingsPlan;
        if(userProfile?.savingsPlans)
        {
            matchingSavingsPlan = userProfile?.savingsPlans.find((plan: { id: number; }) => plan.id === lastContractActiveId);
        }
        
        if(matchingSavingsPlan)
        {
            console.log('SavingsPlan encontrado:', matchingSavingsPlan);
            if(userProfile.status === "4000" || (matchingSavingsPlan.type === 6 && matchingSavingsPlan.status !== 4))
            {
                return{
                    status: true,
                    lastContractActive: userProfile.lastContractActive
                };
            }
        }
        else
        {
            console.warn('No se encontró un SavingsPlan con el Id:', lastContractActiveId);
            return{
                status: false,
            };
        }
    }

    getUserProfile()
    {
        var rawProfile = localStorage.getItem("userprofile");
        if(rawProfile != null)
        {
            return JSON.parse(rawProfile);
        }
        return {};
    }
    setUserProfile(authResponse: any)
    {
        var currentProfile = this.getUserProfile();
        var sanitizedCurrent = sanitizeUserProfileForStorage(currentProfile);
        var sanitizedPayload = sanitizeUserProfileForStorage(authResponse);
        var merged = mergeSanitizedProfile(sanitizedCurrent, sanitizedPayload);

        var fullName: string[] = [];
        var initials: string = "";
        var mainUserIdentity = merged.mainUserIdentity as Record<string, unknown> | undefined;
        if(mainUserIdentity !== undefined && mainUserIdentity != null)
        {
            const fields = ['firstName', 'lastName', 'secondLastName'];

            for(var fieldIndex in fields)
            {
                var field = fields[fieldIndex];
                var fieldValue = mainUserIdentity[field];

                if(fieldValue !== undefined && fieldValue !== null)
                {
                    fullName.push(`${fieldValue}`);
                    var fullNameWords = String(fieldValue).split(" ");
                    if(fullNameWords.length > 0)
                    {
                        for(var wordIndex in fullNameWords)
                        {
                            if(initials.length < 3 && fullNameWords[wordIndex].length > 0)
                            {
                                initials += fullNameWords[wordIndex][0].toUpperCase();
                            }
                        }
                    }
                    else
                    {
                        initials = "--";
                    }
                }
            }
        }

        if(fullName.length === 0)
        {
            var email = merged.email;
            fullName = [email != null ? String(email) : ""];
            initials = '@';
        }

        merged.fullName = fullName.join(" ");
        merged.initials = initials;

        localStorage.setItem("userprofile", JSON.stringify(merged));
    }

    clearUserProfile()
    {
        localStorage.removeItem("userprofile");
    }

    getProcessHours()
    {
        var rawProfile = localStorage.getItem("processHours");
        if(rawProfile != null)
        {
            return JSON.parse(rawProfile);
        }

        return {};
    }
    setProcessHours(response: any)
    {
        localStorage.removeItem("processHours");
        var processHours: IProcessHours[] = [];

        for(let i=0; i<response.length; i++)
        {
            processHours.push(response[i]);
        }

        localStorage.setItem("processHours", JSON.stringify({...processHours}));
    }

    getActivePlan()
    {
        var rawProfile = localStorage.getItem("userActivePlan");
        if(rawProfile != null)
        {
            return JSON.parse(rawProfile);
        }
        return { sync : false };
    }

    setActivePlan(authResponse: any)
    {
        var activePlan = this.getActivePlan();

        activePlan.id = authResponse.planId || authResponse.id;
        activePlan.name = authResponse.planName || authResponse.name;
        activePlan.statusName = authResponse.status || authResponse.statusName;
        activePlan.userId = authResponse.userId;
        activePlan.type = authResponse.type;
        activePlan.outdated = authResponse.outdated;
        activePlan.outdatedContract = authResponse.outdatedContract;
        activePlan.cancelled = authResponse.cancelled;
        activePlan.portfolio = authResponse.portfolio;
        activePlan.fnmContractId = authResponse.fnmContractId;
        activePlan.finametrixContract = authResponse.finametrixContract;
        activePlan.userSubscriptionId = authResponse.userSubscriptionId;
        activePlan.allUserIdentitiesHaveSuitabilityTest = authResponse.allUserIdentitiesHaveSuitabilityTest;
        activePlan.sync = true;

        localStorage.setItem("userActivePlan", JSON.stringify({ ...activePlan }));
    }

    getActiveSubscriptions()
    {
        var rawProfile = localStorage.getItem("activeSubscriptions");
        if(rawProfile != null)
        {
            return JSON.parse(rawProfile);
        }
        return {};
    }
    setActiveSubscriptions(options: any)
    {
        localStorage.removeItem("activeSubscriptions");
        var activeSubscriptions: any[] = [];

        for(let i = 0; i < options.length; i++)
        {
            activeSubscriptions.push(
            {
                key: options[i].id,
                id: options[i].id.toString(),
                text: options[i].text,
                selected: options[i].selected
            });
        }

        localStorage.setItem("activeSubscriptions", JSON.stringify({...activeSubscriptions}));
    }
    setSession(authResult: any)
    {
        localStorage.setItem("email", authResult.email);
        localStorage.setItem("oid", authResult.oid);
    }
    getToken()
    {
        if(localStorage.getItem('access_token') === null)
        {
            return "";
        }

        return localStorage.getItem('access_token')
    }
    getProfile()
    {
        let user;
        let apiProfile;

        if(localStorage.getItem("email") && localStorage.getItem("oid") !== 'undefined')
        {
            user = JSON.parse(localStorage.getItem("profile") as string);
        }
        else
        {
            user = {};
        }

        const profile = Object.assign(user, apiProfile);
        return profile || {};
    }
    getRoles()
    {
        const roles = localStorage.getItem("roles");

        if(roles)
        {
            return JSON.stringify(roles);
        }
        else
        {
            return null;
        }
    }
    /**
     * Cierra la sesión: revoca los tokens en el servidor OAuth (que además destruye su sesión) y limpia el estado local.
     * Si la revocación falla, el estado local se limpia igualmente.
     */
    async logout(): Promise<void>
    {
        try
        {
            // Instancia sin interceptores: la revocación usa la cookie de sesión y no tiene sentido refrescar el token antes
            await axios.create().get(`${serverHost}/oauth/revoke`, {withCredentials: true});
        }
        catch(error)
        {
            console.error("No se ha podido revocar la sesión en el servidor OAuth", error);
        }

        const cookies = new Cookies();
        cookies.remove("statusBarNotifications", {path: "/"});
        localStorage.clear();
    }
    isAuthenticated()
    {
        if(localStorage.getItem("email") && localStorage.getItem("oid") !== 'undefined')
        {
            return true;
        }
        else
        {
            return false
        }
    }
    isSubscribed()
    {
        var userProfile = this.getUserProfile()
        if(userProfile.status !== undefined && userProfile.status !== null)
        {
            return /^[14]/.test(userProfile.status);
        }
        else
        {
            return false;
        }
    }
    isActiveManagementPlan()
    {
        var activePlan = this.getActivePlan();
        if(activePlan.type !== undefined && activePlan.type !== null)
        {
            let result = [0, 1].includes(activePlan.type);
            return result;
        }
        else
        {
            return false;
        }
    }
    isAlchemyPlan()
    {
        var activePlan = this.getActivePlan();
        if(activePlan.type !== undefined && activePlan.type !== null)
        {
            return activePlan.type === 1;
        }
        else
        {
            return false;
        }
    }
    isPromotioned()
    {
        var userProfile = this.getUserProfile()

        if(userProfile.status !== undefined && userProfile.status !== null)
        {
            //Silvia lo comenta porque hemos puesto que las suscripciones con 3000 serán los usuarios con al menos una competición en la que participa
            //return (userProfile.status.toString().startsWith("2") || userProfile.status.toString().startsWith("3"));
            return (userProfile.status.toString().startsWith("2"));
        }
        else
        {
            return false;
        }
    }
    isLastPlanOutdated()
    {
        var plan = this.getActivePlan();

        if(plan.outdated === false)
        {
            return false;
        }
        else
        {
            return true;
        }
    }
    isLastPlanOutdatedContract()
    {
        var plan = this.getActivePlan();
        return plan.outdatedContract;
    }
    isActivePlanCancelled()
    {
        var plan = this.getActivePlan();

        if(plan.cancelled === false)
        {
            return false;
        }
        else
        {
            return true;
        }
    }
    bubbleVisible()
    {
        var userProfile = this.getUserProfile();

        if(userProfile.status !== undefined && userProfile.status !== null)
        {
            return (userProfile.status.toString().startsWith("0") || (userProfile.status.toString().startsWith("2") && userProfile.mainUserIdentity === null))
        }
        else
        {
            return false;
        }
    }
    setQtyPage(number: number)
    {
        localStorage.setItem("qtyPage", String(number));
    }
    getQtyPage()
    {
        if(localStorage.getItem("qtyPage") !== null)
        {
            return localStorage.getItem("qtyPage");
        }
        else
        {
            return 10;
        }
    }
    getExperienceSubscription()
    {
        if(localStorage.getItem("subscriptionPlan") != null)
        {
            return localStorage.getItem("subscriptionPlan");
        }
        else
        {
            return "";
        }
    }
    setExperienceSubscription(value: any)
    {
        localStorage.setItem("subscriptionPlan", String(value));
    }
    deleteExperienceSubscription()
    {
        localStorage.removeItem("subscriptionPlan");
    }
    getRepaymentSubscription()
    {
        if(localStorage.getItem("repaymentSubscription") != null)
        {
            return localStorage.getItem("repaymentSubscription");
        }
        else
        {
            return "";
        }
    }
    setRepaymentSubscription(value: any)
    {
        localStorage.setItem("repaymentSubscription", String(value));
    }
    deleteRepaymentSubscription()
    {
        localStorage.removeItem("repaymentSubscription");
    }
    getSavingsPlanElementsStatus(): SavingsPlanElementsStatus
    {
        var rawSavingsPlanElementsStatus = localStorage.getItem("savingsPlanElementsStatus");
        if(rawSavingsPlanElementsStatus !== null)
        {
            return JSON.parse(rawSavingsPlanElementsStatus);
        }

        return{
            isSubscribed: false,
            isOutdatedContract: false,
            sync: false
        };
    }
    setSavingsPlanElementsStatus(elementsStatus: SavingsPlanElementsStatus)
    {
        localStorage.setItem("savingsPlanElementsStatus", JSON.stringify(elementsStatus));
    }
}

const authClient = new Auth();

export default authClient;